import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../api/server";
import { VALIDATE_CLIENT_SUBDOMAIN } from "../api/apiPath";
import LoadingComponent from "./common/LoadingComponent";

export default function ValidateClient({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isValidClient, setIsValidClient] = useState(null);

  const getClientNameFromPath = () => {
    try {
      const match = window.location.pathname.match(/^\/client\/([^/]+)/i);
      return match?.[1] || "";
    } catch {
      return "";
    }
  };

  useEffect(() => {
    const validateClient = async () => {
      const clientSubDomainName = getClientNameFromPath();

      if (!clientSubDomainName) {
        setIsValidClient(false);
        setLoading(false);
        return;
      }

      try {
        const response = await http.get(VALIDATE_CLIENT_SUBDOMAIN, {
          params: { clientSubDomainName },
        });

        if (response?.data?.success) {
          setIsValidClient(true);
        } else {
          setIsValidClient(false);
        }
      } catch (error) {
        console.error(" Validate Client API Error:", error);
        setIsValidClient(false);
      } finally {
        setLoading(false);
      }
    };

    validateClient();
  }, []);
  

  if (loading) {
    return <LoadingComponent loading={true} />;
  }

  if (!isValidClient) {
    // const subdomain = getClientNameFromPath();
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
        <h2 className="text-danger fw-bold">Access Denied</h2>
        <p className="mt-3 fs-5">
          This URL is not valid.
          <br />
          Please check your link or contact your administrator.
        </p>
        <button
          type="button"
          className="btn btn-primary mt-3"
          onClick={() => navigate("/client")}
        >
          Back to Login Page
        </button>
      </div>
    );
  }
  return children;
}
